import { render } from "./QuestionnaireItemView.vue?vue&type=template&id=4f94e945"
import script from "./QuestionnaireItemView.vue?vue&type=script&lang=js"
export * from "./QuestionnaireItemView.vue?vue&type=script&lang=js"

import "./QuestionnaireItemView.vue?vue&type=style&index=0&id=4f94e945&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__